import { FC, useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  VStack,
  useColorModeValue,
  Spinner,
  Center,
} from "@chakra-ui/react";
import useSchedule from "hooks/use-schedule";
import LoadingComponent from "components/Main/Loading";
import dayjs from "dayjs";

interface ConfirmScheduleProps {
  id: number;
}

const ConfirmSchedule: FC<ConfirmScheduleProps> = ({ id }) => {
  const [isOpen, setIsOpen] = useState(false);
  const {
    getScheduleAvaliableDateById,
    datesAvaliable,
    confirmReSchedule,
    loadingModal,
  } = useSchedule();
  const [selectedId, setSelectedId] = useState(null);
  const [produtcManager, setProductManager] = useState(null);
  const colorSchemeButton = useColorModeValue("green", "white");
  const bgLoading = useColorModeValue("white", "#111C44");

  const handleCheckboxChange = (id: any) => {
    setSelectedId((prevSelectedId: any) => (prevSelectedId === id ? null : id));
  };
  const colorSpinner = useColorModeValue("black", "white");

  const abrirModal = () => {
    setIsOpen(true);
  };

  const fecharModal = () => {
    setIsOpen(false);
  };

  const handleConfirmarAgendamento = () => {
    // Lógica de confirmação de agendamento aqui
    const obj = {
      id: id,
      schedulingDate: selectedId,
    };
    confirmReSchedule(obj, id);
    setSelectedId(null);
    setProductManager(null);
    setIsOpen(false);
  };

  const getDayOfWeek = (dateInput: string): string => {
    const date = new Date(dateInput);
    const daysOfWeek = [
      "Domingo",
      "Segunda-feira",
      "Terça-feira",
      "Quarta-feira",
      "Quinta-feira",
      "Sexta-feira",
      "Sábado",
    ];
    // date.setDate(date.getDate() + 1);
    const dayOfWeekIndex = date.getDay();
    return daysOfWeek[dayOfWeekIndex];
  };

  useEffect(() => {
    if (isOpen) {
      if (id !== 0) {
        getScheduleAvaliableDateById(id);
      }
    }
  }, [isOpen, getScheduleAvaliableDateById]);

  return (
    <>
      <Button
        onClick={abrirModal}
        colorScheme={colorSchemeButton}
        isDisabled={id === 0}
        variant={id !== 0 ? "solid" : "outline"}
        color="white"
      >
        Ver Datas Disponíveis
      </Button>

      <Modal isOpen={isOpen} onClose={fecharModal} size="lg">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader
            paddingTop={2}
            paddingBottom={2}
            paddingLeft={4}
            paddingRight={4}
            textColor={"gray.200"}
            background={"#1d5840"}
            borderTopLeftRadius={5}
            borderTopRightRadius={5}
            borderBottom="3px solid #ECC94B"
          >
            Agendamento
          </ModalHeader>
          <ModalCloseButton color="white" />
          <ModalBody>
            <VStack spacing={4}>
              <Button
                colorScheme="green"
                onClick={handleConfirmarAgendamento}
                isDisabled={selectedId === null}
              >
                Confirmar Agendamento
              </Button>
              <Box overflow="auto" maxW="540px" maxH="400px">
                {loadingModal ? (
                  <>
                    <Box h={40}>
                      <Center pt={10}>
                        <Spinner
                          thickness="4px"
                          speed="0.65s"
                          emptyColor="gray.200"
                          color={colorSpinner}
                          size="xl"
                        />
                      </Center>
                      <Text
                        color={colorSpinner}
                        marginTop="4"
                        fontSize="xl"
                        fontWeight="bold"
                      >
                        Buscando dados
                      </Text>
                    </Box>
                  </>
                ) : (
                  <>
                    <Table>
                      <Thead>
                        <Tr bg="green.600" color="white">
                          <Th></Th>
                          <Th color="white">Data Prevista</Th>
                          <Th color="white">Dia da Semana</Th>
                          <Th color="white">Vagas </Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {datesAvaliable.map((item: any) => (
                          <Tr>
                            <Td>
                              <Checkbox
                                onChange={() => {
                                  setProductManager(item.productManagerId);
                                  handleCheckboxChange(item.dateAvailable);
                                }}
                                colorScheme="blue"
                                borderColor="blackAlpha.400"
                                isChecked={selectedId === item.dateAvailable}
                              />
                            </Td>
                            <Td>
                              {dayjs(item.dateAvailable)
                                // .subtract(-1, "day")
                                .format("DD/MM/YYYY ")}
                            </Td>
                            <Td>{getDayOfWeek(item.dateAvailable)}</Td>
                            <Td>{item.totalAvailableDays}</Td>
                          </Tr>
                        ))}
                      </Tbody>
                    </Table>
                  </>
                )}
              </Box>
            </VStack>
          </ModalBody>
          <ModalFooter></ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default ConfirmSchedule;
